import qs from 'qs';
import moment from 'moment';

export const SEARCH_CARS_URL = (params) => {
	const queryParams = {
		with_drop_city_only: params.dropInDifferentCity ? '1' : '0',
		city_out_uuid: params.dropCity ? params.dropCity.uuid : '',
		address: params.pickupLocation ? `${params.pickupLocation.address} Airport` : '',
		pickup_date: params.pickupDate ? moment(params.pickupDate).format('YYYY-MM-DD') : '',
		drop_date: params.dropDate ? moment(params.dropDate).format('YYYY-MM-DD') : '',
		delivery: 0,
		delivery_lat: null,
		delivery_lng: null,
		delivery_address: '',
		sorting_type: 'near_me',
		special_offers: 0,
	};

	if (params.kiosk) {
		queryParams.kiosk = params.kiosk;
	}
	if (params.airportUuid) {
		queryParams.airport_uuid = params.airportUuid
	}


	const queryString = qs.stringify(queryParams);

	return `car?${queryString}`;
};
